export const blockIconsAudioandvideoEqualizerNew = (
	<span className='material-symbols-outlined'>equalizer</span>
);
